module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h2', {
    staticClass: "chapter_title"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _vm._v("CHAPTER 1")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/colorline.jpg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_vm._v("BIRTHDAYS")]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("The day you were born has a formidable hand in determining both your personality and the direction your life will take. Find the fortune for your own birthday below, or look to the birthdays of friends, family members, and others to learn more about them.")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("MONTH")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("BIRTHSTONE (AND"), _c('br'), _vm._v("MEANING)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("FLOWER")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("COLORS")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("January")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Garnet (constancy)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Carnation")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Black, dark blue, and red")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("February")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Amethyst (sincerity)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Violet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Light blue and yellow")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("March")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Bloodstone (courage)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Jonquil")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("White and light blue")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("April")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Diamond (innocence)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Sweet pea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Yellow and red")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("May")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Emerald (success in love)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Lily of the valley")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Yellow, red, and green")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("June")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Pearl (health)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Rose")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("White, cream, and light blue")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("July")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Ruby (contented mind)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Larkspur")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Green, russet, and red")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("August")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Sardonyx (conjugal felicity)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Gladioli")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Orange, red, and light green")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("September")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Sapphire (love)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Aster")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Brown and dark blue")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("October")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Opal (hope)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Calendula")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("White and yellow")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("November")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Topaz (fidelity)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Chrysanthemum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Dark blue, red, and yellow")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("December")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Turquoise (prosperity)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Narcissus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "first2_noindent"
  }, [_vm._v("Indigo, blue-green, and green")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa76209","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06-part01.vue
// module id = 72
// module chunks = 0